import { ItemFromEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, CreateDateColumn, Entity, Index, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { PoCreation } from "./po-creation.entity";

@Entity("purchase_order_items")

export class PoItems {

    @PrimaryGeneratedColumn("increment", {
        name: "purchase_order_items_id"
    })
    purchaseOrderItemId: number;

    @Column("int", {
        name: "purchase_order_id"
    })
    purchaseOrderId: number;

    @Column("int", {
        nullable: true,
        name: "bom_item_id"
    })
    bomItemId:number;

    @Column("int", {
        nullable: true,
        name: "sale_order_id"
    })
    saleOrderId:number

    @Column("int", {
        nullable: false,
        name: "item_category"
    })
    itemCategory: number;

    @Column("int", {
        nullable: false,
        name: "item_sub_category_id"
    })
    itemSubCategoryId: number;

    @Column("int", {
        nullable: false,
        name: "item_name"
    })
    itemName: number;
    @Column("int", {
        nullable: false,
        name: "size",
        default:0,
        comment: "size id not using"
    })
    size: number;
    @Column("decimal", {
        nullable: false,
        name: "item_quantity",
        default:0
    })
    itemQuantity: number;
    @Column("decimal", {
        nullable: false,
        name: "received_quantity",
        default:0
    })
    receivedQuantity: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "item_cost",
        default: 0
    })
    itemCost: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "discount_per",
        default: 0
    })
    discountPer: number;


    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "discount",
        default: 0
    })
    discount: number;

    @Column("decimal", {
        nullable: false,
        name: "tax_per",
        default:0
    })
    taxPer: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "tax",
        default: 0
    })
    tax: number;


    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "transportation",
        default: 0
    })
    transportation: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "sub_amount",
        default: 0
    })
    subAmount: number;


    @Column({
        type: 'enum',
        nullable: false,
        enum: StatusEnum,
        default: StatusEnum.OPEN,
        name: "po_status"
    })
    poStatus: StatusEnum;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "from_po",
    })
    fromPo: boolean;


    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "status"
    })
    isActive: boolean | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("int", {
        nullable: false,
        name: "asn_qty",
        default:0
    })
    asnQty: number;

    @ManyToOne(type => PoCreation, poCreation => poCreation.poCreationItemsInfo, { nullable: false })
    @JoinColumn({ name: "purchase_order_id" })
    poCreationInfo: PoCreation[];
}

